import { AppWindow, Globe, Server } from 'lucide-react';

import {
  RadioCardGroup,
  type RadioCardOption,
} from '@/components/ui/radio-card-group';
import { SeedTypeOption } from '@/types';

const seedTypeOptions: RadioCardOption<SeedTypeOption>[] = [
  {
    value: SeedTypeOption.DOMAIN_CIDR,
    label: 'Network Assets',
    description:
      'Add domain names, IP addresses, and CIDR ranges for network scanning',
    icon: Globe,
  },
  {
    value: SeedTypeOption.WEB_APPLICATION,
    label: 'Web Applications',
    description: 'Add web application URLs for security testing',
    icon: AppWindow,
  },
  {
    value: SeedTypeOption.WEB_SERVICE,
    label: 'Web Services',
    description: 'Add web service endpoints',
    icon: Server,
  },
];

interface SeedTypeSelectorProps {
  value: SeedTypeOption | null;
  onChange: (type: SeedTypeOption) => void;
}

export const SeedTypeSelector = ({
  value,
  onChange,
}: SeedTypeSelectorProps) => {
  return (
    <RadioCardGroup
      value={value}
      onChange={onChange}
      options={seedTypeOptions}
      ariaLabel="Select seed type"
    />
  );
};
